import * as React from 'react';
const SvgVideo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={241}
    height={240}
    fill="none"
    viewBox="0 0 241 240"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M.5 0h240v240H.5z" />
    <path
      fill="#E9F2FF"
      d="M120.5 204c46.392 0 84-37.608 84-84s-37.608-84-84-84-84 37.608-84 84 37.608 84 84 84"
    />
    <path
      fill="#59F"
      d="M120.444 56s-56.257 0-70.377 3.67c-7.56 2.113-13.785 8.34-15.898 16.013C30.5 89.807 30.5 119.056 30.5 119.056s0 29.359 3.669 43.261c2.113 7.673 8.227 13.789 15.898 15.902C64.298 182 120.444 182 120.444 182s56.369 0 70.489-3.67c7.671-2.113 13.785-8.118 15.786-15.902 3.781-14.013 3.781-43.261 3.781-43.261s.111-29.36-3.781-43.484c-2.001-7.673-8.115-13.789-15.786-15.79C176.813 56 120.444 56 120.444 56"
    />
    <path fill="#fff" d="m149.351 119.056-46.807-27.024v53.936z" />
    <rect width={16} height={4} x={66.5} y={39} fill="#16E" rx={1} />
    <rect width={32} height={4} x={66.5} y={33} fill="#16E" rx={1} />
    <rect width={20} height={20} x={42.5} y={28} fill="#59F" rx={4} />
    <path
      fill="#CDF"
      d="M228.5 91.272a10.7 10.7 0 0 1-2.658 7.071 10.73 10.73 0 0 1-8.09 3.657H182.02a14.5 14.5 0 0 1-2.314-.191 13.5 13.5 0 0 1-8.307-4.939 13.47 13.47 0 0 1 1.167-17.993 13.5 13.5 0 0 1 8.875-3.828 19 19 0 0 1 8.257-8.777 19.04 19.04 0 0 1 22.613 3.438 18.98 18.98 0 0 1 5.267 10.834h.162a10.76 10.76 0 0 1 7.607 3.136 10.72 10.72 0 0 1 3.153 7.592M8.5 88.073a7.94 7.94 0 0 0 2.314 5.605A7.9 7.9 0 0 0 16.402 96h26.234a9.9 9.9 0 0 0 6.904-2.858 9.96 9.96 0 0 0 2.958-6.88 9.97 9.97 0 0 0-2.667-6.999 9.9 9.9 0 0 0-6.778-3.148 14 14 0 0 0-6.066-6.448 13.94 13.94 0 0 0-8.71-1.508 13.96 13.96 0 0 0-7.87 4.038 14.04 14.04 0 0 0-3.881 7.967h-.119a7.9 7.9 0 0 0-5.585 2.313A7.94 7.94 0 0 0 8.5 88.073M32.5 135.53a8.5 8.5 0 0 0 2.081 5.58 8.38 8.38 0 0 0 5.217 2.812q.551.078 1.108.078h27.946a11 11 0 0 0 1.818-.151 10.55 10.55 0 0 0 6.543-3.886 10.7 10.7 0 0 0 2.265-7.304 10.68 10.68 0 0 0-3.184-6.947 10.53 10.53 0 0 0-6.987-3 14.94 14.94 0 0 0-6.46-6.921 14.8 14.8 0 0 0-9.293-1.62 14.84 14.84 0 0 0-8.392 4.332 15.04 15.04 0 0 0-4.124 8.544h-.132a8.36 8.36 0 0 0-5.949 2.486 8.5 8.5 0 0 0-1.821 2.752 8.5 8.5 0 0 0-.636 3.245"
    />
    <path
      fill="#8BF"
      fillRule="evenodd"
      d="M178 209.398a1.9 1.9 0 0 0 1.904-1.898 1.9 1.9 0 0 0-1.904-1.898 1.9 1.9 0 0 0-1.904 1.898c0 1.042.847 1.898 1.904 1.898m0 2.602a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M168 30.398a1.9 1.9 0 0 0 1.904-1.898A1.9 1.9 0 0 0 168 26.602a1.9 1.9 0 0 0-1.904 1.898c0 1.042.847 1.898 1.904 1.898M168 33a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
      clipRule="evenodd"
    />
    <path
      fill="#59F"
      d="M123.509 1.568c.504-2.09 3.478-2.09 3.982 0l.765 3.166c.18.747.763 1.33 1.51 1.51l3.166.765c2.091.504 2.091 3.478 0 3.982l-3.166.765c-.747.18-1.33.763-1.51 1.51l-.765 3.166c-.504 2.09-3.478 2.09-3.982 0l-.765-3.166a2.05 2.05 0 0 0-1.51-1.51l-3.166-.765c-2.091-.504-2.091-3.478 0-3.982l3.166-.765a2.05 2.05 0 0 0 1.51-1.51zM127.396 215.655c.534-2.207 3.674-2.207 4.208 0l.712 2.941a2.17 2.17 0 0 0 1.597 1.595l2.929.705c2.211.532 2.211 3.676 0 4.208l-2.929.705a2.17 2.17 0 0 0-1.597 1.595l-.712 2.941c-.534 2.207-3.674 2.207-4.208 0l-.712-2.941a2.17 2.17 0 0 0-1.597-1.595l-2.929-.705c-2.211-.532-2.211-3.676 0-4.208l2.929-.705a2.17 2.17 0 0 0 1.597-1.595z"
    />
    <path
      fill="#CDF"
      d="M58.561 204.444c-.37-1.467.997-2.781 2.46-2.366l8.044 2.283c1.463.415 1.925 2.249.832 3.301l-6.01 5.784c-1.094 1.051-2.922.533-3.292-.934z"
    />
  </svg>
);
export default SvgVideo;
